import { Component, Input } from '@angular/core';

@Component({ selector: 'greco-info-card-image', templateUrl: './image.component.html', styleUrls: ['./image.component.scss'] })
export class InfoCardImageComponent {
  @Input() url: string;
  @Input() shape: 'square' | 'circle' | 'rounded' = 'rounded';
}
